import { logError as e, setLoggingMode as i, LOG_MODE as o } from "@ado/error-logger";
class n {
  logError(r, s) {
    e(
      this.buildErrorMessage(r),
      s ?? window.location.href,
      0,
      r
    );
  }
  forceConsoleLogging() {
    i(o.CONSOLE);
  }
  buildErrorMessage(r) {
    let s = r.message;
    return r.cause && (s += ` [Cause: ${this.stringifyCause(r.cause)}]`), s;
  }
  stringifyCause(r) {
    return r instanceof Error ? this.buildErrorMessage(r) : JSON.stringify(r);
  }
}
export {
  n as DefaultErrorLogger
};
//# sourceMappingURL=default-error-logger.js.map
